import React from 'react';
import './App.css';
import Router from './router/Router';
import { routes } from './router/config';
import LoginComponent from './components/LoginComponent/LoginComponent';
import useLogged from './components/LoginComponent/useLogged';

function App() {
  const  {logged, setLogged} = useLogged();

  if (!logged) {
      return <LoginComponent setLogged={setLogged} />
  }

  return (
    <div className="App">
      <Router routes={routes} />
    </div>
  );
}

export default App;
